module.exports = __webpack_public_path__ + "static/img/kapasitas-stargroup.e62a524.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/kapasitas-stargroup.png
// module id = VpkW
// module chunks = 1